import React, {useEffect, useState} from "react";
import {CssBaseline, MuiThemeProvider} from "@material-ui/core";
import NavBar from "./components/NavBar";
import InvoiceList from "./pages/InvoiceList/InvoiceList";
import {
    Route,
    Switch,
} from "react-router-dom";
import ViewInvoice from "./pages/ViewInvoice/ViewInvoice";
import LoginPage from "./pages/Authentication/LoginPage";
import './App.css'
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./pages/NotFound/NotFound";
import CustomTheme from "./theme/CustomTheme";

function App() {
    const [appTheme, setAppTheme] = useState('light');

    useEffect(() => {
        let theme = localStorage.getItem('appTheme');
        if (theme) {
            setAppTheme(theme);
        } else {
            localStorage.setItem('appTheme', appTheme);
        }

    }, [appTheme])
    const handleThemeClick = () => {
        let theme = appTheme === 'light' ? 'dark' : 'light';
        setAppTheme(theme)
        localStorage.setItem('appTheme', theme)
    }

    return (
        <MuiThemeProvider theme={CustomTheme(appTheme)}>
            <React.Fragment>
                <CssBaseline/>
                <NavBar theme={appTheme} handleThemeClick={handleThemeClick}/>
                <Switch>

                    <ProtectedRoute exact path="/" component={InvoiceList}/>
                    <Route exact path="/login" component={LoginPage}/>
                    <Route exact path="/NotFound" component={NotFound}/>
                    <ProtectedRoute exact path="/ViewInvoice/:source/:invoiceNumber" component={ViewInvoice}/>
                </Switch>
            </React.Fragment>
        </MuiThemeProvider>
    );
}

export default App;
